import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

const triggerClass =
  'h-8 rounded-full bg-transparent px-4 py-0 text-sm font-medium text-grey-600 hover:bg-transparent hover:text-grey-900 data-[state=active]:bg-grey-900 data-[state=active]:text-true-white data-[state=active]:shadow-none dark:text-muted-foreground dark:hover:text-foreground dark:data-[state=active]:bg-foreground dark:data-[state=active]:text-background';

export function UsageScopeTabs({
  tab,
  onTabChange,
}: {
  tab: 'personal' | 'organization';
  onTabChange: (tab: 'personal' | 'organization') => void;
}) {
  const { t } = useTranslation();

  return (
    <Tabs value={tab} onValueChange={(value) => onTabChange(value as 'personal' | 'organization')}>
      <TabsList className="h-auto gap-1 rounded-full border-grey-100 bg-true-white p-1 dark:border-border dark:bg-card">
        <TabsTrigger value="personal" className={triggerClass}>
          {t('PERSONAL')}
        </TabsTrigger>
        <TabsTrigger value="organization" className={triggerClass}>
          {t('ORGANIZATION')}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
